import React from 'react';
import logo from "../assets/horizontal-logo.png";
import { FiUser, FiMail, FiLock, FiCheck } from 'react-icons/fi';

const Signup = ({ onLoginClick }) => {
  return (
    <div className="flex flex-col font-mono-sans items-center justify-center h-screen bg-black">
      <div className="absolute top-0 left-0 right-0 flex justify-center mt-2">
        <img src={logo} alt="Logo" className="w-24 h-24" />
      </div>
      <div className="absolute top-0 right-0 mt-6 mr-6">
        <p className="text-base text-gray-400">Already have an account ? <span className="text-emerald-300 mr-4 cursor-pointer" onClick={onLoginClick}>Login</span></p>
      </div>
      <div className="flex flex-col mt-16 items-center justify-center">
        <form className="flex flex-col items-center justify-center ">
          <div className="mb-4 flex items-center">
            <FiUser className="text-gray-400 mr-4" />
            <input type="text" className="w-72 bg-transparent px-3 py-2 border-b border-gray-400 rounded-none transition-transform duration-300 hover:scale-105 focus:outline-none" placeholder="Full Name" />
          </div>
          <div className="mb-4 flex items-center">
            <FiMail className="text-gray-400 mr-4" />
            <input type="email" className="w-72 bg-transparent px-3 py-2 border-b border-gray-400 rounded-none transition-transform duration-300 hover:scale-105 focus:outline-none" placeholder="Email / Username" />
          </div>
          <div className="mb-4 flex items-center">
            <FiLock className="text-gray-400 mr-4" />
            <input type="password" className="w-72 bg-transparent px-3 py-2 border-b border-gray-400 rounded-none transition-transform duration-300 hover:scale-105 focus:outline-none" placeholder="Password" />
          </div>
          <div className="mb-4 flex items-center">
          <FiCheck className="text-gray-400 mr-4" />
            <input type="password" className="w-72 bg-transparent px-3 py-2 border-b border-gray-400 rounded-none transition-transform duration-300 hover:scale-105 focus:outline-none" placeholder="Confirm Password" />
          </div>
          <div className="mb-4 py-2 flex items-center">            
            <label className="text-gray-400 pr-20">
              <input type="radio" name="gender" className="mr-2" />
              Male 
            </label>
            <label className="text-gray-400 px-2">
              <input type="radio" name="gender" className="mr-2" />
              Female
            </label>
          </div>
          <button type="submit" className="w-80 m-4 bg-emerald-600 text-white py-2 transition-transform duration-500 hover:scale-110">Sign Up</button>
        </form>
      </div>
    </div>
  );
};

export default Signup;
